const RtbPixel = {
  format: (action, pixelKey) => {
    const PIXEL_BASE_URL = 'https://b.sharethrough.com';

    if (action === 'hosted-video') {
      return `${PIXEL_BASE_URL}/video_swap?key=${pixelKey}`;
    } else if (action === 'scroller') {
      return `${PIXEL_BASE_URL}/scroller?key=${pixelKey}`;
    } else if (action === 'slideshow') {
      return `${PIXEL_BASE_URL}/slideshow?key=${pixelKey}`;
    } else if (action === 'carousel') {
      return `${PIXEL_BASE_URL}/carousel?key=${pixelKey}`;
    } else if (action === 'clickout') {
      return `${PIXEL_BASE_URL}/native_display?key=${pixelKey}`;
    } else if (action === 'banner') {
      return `${PIXEL_BASE_URL}/native_display?key=${pixelKey}`;
    } else {
      throw new Error('Unsupported action for RTB pixel');
    }
  }
};

export default RtbPixel;
